export default {
  latestUploads: (state) => state.latestUploadsConnection?.assets || [],
  newCases: (state) => state.newCasesConnection?.assets || [],
};
